import { Theme } from '@mui/material/styles';
import mainBakcground from 'assets/images/background_512.png';

export const homeBackgroundStyles = ({ breakpoints }: Theme) => ({
    backgroundImage: `url(${mainBakcground})`,
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '700px auto',
    backgroundPositionY: 120,
    maxWidth: 1200,
    [breakpoints.down('sm')]: { backgroundSize: '500px auto', backgroundPositionY: 150 },
});

export const titleStyles = ({ spacing }: Theme) => ({
    padding: spacing(12, 3),
    backgroundColor: '#fff',
});

export const carouselBlockStyles = ({ spacing, breakpoints }: Theme) => ({
    height: 500,
    padding: spacing(0, 3),
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});

export const descriptionStyles = ({ spacing, typography }: Theme) => ({
    fontSize: typography.pxToRem(20),
    textAlign: 'justify',
    padding: spacing(20, 3),
    minHeight: 1010,
    maxWidth: 700,
    margin: spacing(0, 'auto', 0),
    backgroundColor: '#fff',
    whiteSpace: 'pre-wrap',
});

export const buttonStyles = ({ spacing }: Theme) => ({
    margin: spacing(30, 'auto'),
    width: spacing(40),
    padding: spacing(2),
});
